import { render, staticRenderFns } from "./LbPlaceOrderPro.vue?vue&type=template&id=f001d21a&scoped=true&"
import script from "./LbPlaceOrderPro.vue?vue&type=script&lang=js&"
export * from "./LbPlaceOrderPro.vue?vue&type=script&lang=js&"
import style0 from "./LbPlaceOrderPro.vue?vue&type=style&index=0&id=f001d21a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f001d21a",
  null
  
)

export default component.exports